<template>
	<div id="selectAddress">
		<!--头部-->
		<mt-header title="选择收货地址"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
		  <a href="javascript:;" slot="right" @click="tomanageAddress">
		    <mt-button >管理</mt-button>
		  </a>
 	    </mt-header>
 	    
 	    <!--地址列表-->
 	    <div class="selectAddresslist">
 	    	<ul class="sAullist">
 	    		<li v-for="(item,index) in addressList" @click="tomenu(item.id)">
 	    			<div class="sAliwrap">
 	    				<p class="sAp1 clearfix font-size10"><span class="sApersonname">收货人：<i>{{item.name}}</i></span> <span class="sAphonenumber">{{item.phone}}</span></p>
 	    				<p class="sAdefault font-size8" :class="{displayBlock:item.flag==1}">[默认地址]</p>
 	    				<p class="sAp2 font-size8"><span class="sAp2-span1">收货地址：</span><span class="sAp2-span2">{{item.address}}</span></p>
 	    			</div>
 	    		</li >
 	    	</ul>
 	    </div>
		<!--{{order}}-->
		<!--添加新地址-->
		<p><input type="button" value="添加新地址" class="btnaddaddress" @click="toaddAddress"></p>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				page:1,  //请求地址页数
				username:localStorage.getItem("username"),   //用户名
				addressList:[],  //地址列表
			    addressLength:0, //地址数量
			    order:this.$route.query.label,//实物订单路由传过来的标志
			    sign:'select', //从选择地址列表中跳到管理列表的标志
			}
		},
		created:function(){
			this.showaddressList();
	    },
		methods:{
			//返回
			returnBack(){
	          //this.$router.back();
	          this.$router.push({path:"/Order/index"});
	        },
	        //管理按钮
	        tomanageAddress(){
	          localStorage.setItem("sign",this.sign);
	          this.$router.push("/UserCenter/manageAddress");
	        },
	        //底部添加新地址按钮
	        toaddAddress(){
	          localStorage.setItem("addressLength",this.addressLength);
	          this.$router.push("/UserCenter/addAddress?label=selectAd");
	        },
	        //实物订单点击选择地址
	        tomenu(selectAdid){
//	        	this.$router.back();
	           this.$router.push({path: "/Order/index",query:{selectId:selectAdid}});
	        },
	        //请求地址
	    	showaddressList(){
	    		this.$http.post(this.URL_PREFIX+"/user/findAddressAll.net",{uid:this.username,page:this.page,rows:25})
			  	  .then((res) =>{
			  	   this.addressList=res.data.rows;
			  	   //console.log('选择地址请求回来了');
			  	   //console.log(res.data.rows);
			  	   this.addressLength=res.data.rows.length;
			  	  });
	    	}
		}
	}
</script>

<style scoped="scoped">
.mint-header {
   background: #ff8920;
}
.btnaddaddress{
    width: 100%;
    height: 40px;
    background: #ff8920;
    color: #fff;
    font-size: 1.0rem;
    border: none;
    line-height: 40px;
    position: fixed;
    bottom: 0;
}
.selectAddresslist{
	margin-top: 40px;
}
.sAullist li{
    border-bottom: 1px solid #e0e0e0;
}
.sAliwrap{
	padding: 10px 10px 15px 10px;
}
.sApersonname{
	float: left;
}
.sAphonenumber{
	float: right;
}
.sAp1{
	margin-bottom: 4px;
}
.sAdefault{
	margin-bottom: 4px;
	color: #ff8900;
	display: none;
}
.sAp2-span3{
	margin-left: 5px;
}
.displayBlock{
	display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/UserCenter/selectAddress.vue